import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Footer from './Footer';
import { useJobs, useCategories } from '../hooks/useApi';
import { Link } from 'react-router-dom';
const Categories = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  
  // Use React Query hooks
  const { data: jobsData, isLoading: jobsLoading, error: jobsError } = useJobs();
  const { data: categoriesData, isLoading: categoriesLoading } = useCategories();

  // Combine loading states
  const isLoading = jobsLoading || categoriesLoading;

  // ✅ Move this function up here
  const getCategoryIcon = (categoryName) => {
    switch(categoryName.toLowerCase()) {
      case 'wfh': return 'fa-house';
      case 'internship': return 'fa-graduation-cap';
      case 'drive': return 'fa-car';
      case 'batches': return 'fa-users';
      default: return 'fa-briefcase';
    }
  };

  
  // Transform categories data
  const categories = categoriesData && jobsData ? Object.entries(categoriesData).map(([key, value]) => {
    const count = jobsData.filter(job => job.category.toString() === key).length;

    return {
      value: key,
      displayName: value,
      icon: getCategoryIcon(value), // ✅ Now it's safe to call
      urlSlug: value.toLowerCase().replace(/\s+/g, '-'),
      jobs: count
    };
  }) : [];

 

  // Filter categories based on search term
  const filteredCategories = categories.filter(category =>
    category.displayName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCategoryClick = (urlSlug) => {
    navigate(`/category/${urlSlug}`);
  };
  
  // Generate meta description
  const generateMetaDescription = () => {
    const categoryCount = categories.length;
    const totalJobs = categories.reduce((acc, cat) => acc + cat.jobs, 0);
    
    return `Browse ${categoryCount} job categories with ${totalJobs} open positions. Find job opportunities in various fields including remote work, internships, and more.`;
  };

  return (
    <>
      <Helmet>
        <title>Browse Job Categories | Fresher Job Adda</title>
        <meta name="description" content={generateMetaDescription()} />
        <meta name="keywords" content="job categories, job search, careers, employment, job opportunities, job listings" />
        <link rel="canonical" href={`${window.location.origin}/categories`} />
        <meta property="og:title" content="Browse Job Categories | Fresher Job Adda" />
        <meta property="og:description" content={generateMetaDescription()} />
        <meta property="og:url" content={`${window.location.origin}/categories`} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Browse Job Categories | Fresher Job Adda" />
        <meta name="twitter:description" content={generateMetaDescription()} />
      </Helmet>
      
      <Header />
      <div className="page-title">
        <div className="container">
          <div className="page-caption">
            <h2>Browse Categories</h2>
            <p>
              <Link to="/">Home</Link>
              <i className="fa fa-angle-double-right"></i>
              Categories
            </p>
          </div>
        </div>
      </div>

      <section className="padd-top-80 padd-bot-80">
  <div className="container">
    <div className="row">
      <div className="col-md-12">
        <div className="input-group mb-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search categories..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
    </div>

    <div className="row">
      {isLoading ? (
        <div className="col-12 text-center">Loading categories...</div>
      ) : jobsError ? (
        <div className="col-12 text-center">
          Error loading categories: {jobsError.message}
        </div>
      ) : (
        (() => {
          const filtered = filteredCategories.filter((cat) => cat.jobs > 0);
          return filtered.length === 0 ? (
            <div className="col-12 text-center">No categories found</div>
          ) : (
            filtered.map((category, index) => (
              <div key={index} className="col-md-3 col-sm-6 mb-4">
                <div
                  className="utf_category_box_area"
                  onClick={() => handleCategoryClick(category.urlSlug)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="utf_category_desc">
                    <div className="utf_category_icon">
                      <i
                        className={`fa-solid ${category.icon}`}
                        aria-hidden="true"
                      ></i>
                    </div>
                    <div className="category-detail utf_category_desc_text">
                      <h4>{category.displayName}</h4>
                      <p>
                        {category.jobs}{' '}
                        {category.jobs === 1 ? 'Job' : 'Jobs'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          );
        })()
      )}
    </div>
  </div>
</section>

      <Footer />
    </>
  );
};

export default Categories; 